import React from 'react';
import { RouteName } from 'components/dynamic-page/route-matchers';
import { useUserContext } from 'contexts';
import { SearchBox, UserMenu, CountrySwitcherSection, SavedSearchesNav, MenuDropdown, HeaderNavMenu } from './';
import styles from '../style.module.scss';
import { headerIds } from 'constants/test-constants';

type DesktopNavigationProps = {
  userLinks: any[];
  routeName?: RouteName;
  menuTrigger?: React.ReactNode;
  userTrigger?: React.ReactNode;
};

export const DesktopNavigation = ({ userLinks, routeName, menuTrigger, userTrigger }: DesktopNavigationProps) => {
  const { isCrawler } = useUserContext();

  return (
    <>
      <SearchBox 
        routeName={routeName}
        searchButtonClassName={styles['zoocasa-search-button']}
        searchIconClassName={styles['search-icon']}
        headerIconClassName={styles['header-icon']}
        panelClassName={styles.panel}
        searchIconTestId={headerIds.headerSearchIcon}
        mapHeaderTestId={headerIds.mapHeaderDesktop}
      />
      
      <HeaderNavMenu isCrawler={isCrawler} />
      
      <UserMenu 
        userLinks={userLinks}
        loginTestId={headerIds.loginHeader}
        loggedInTestId={headerIds.loggedInUser}
        additionalComponents={<SavedSearchesNav />}
        userTrigger={userTrigger}
      />
      
      <CountrySwitcherSection />
      
      <MenuDropdown isCrawler={isCrawler} menuTrigger={menuTrigger} />
    </>
  );
}; 